/* eslint-disable camelcase */
// context
import documentContext from '../../contexts/translate/pt.json'

// components
import AddRecordUniq from '../../components/AddRecordingUniq/translate/pt.json'
import header_pt from '../../components/Header/translate/pt.json'
import printButton from '../../components/PrintButton/translate/pt.json'
import sidebar_pt from '../../components/Sidebar/translate/pt.json'
import webcamStreamComponent from '../../components/Webcam/translate/pt.json'
// pages (/pages)
import pageClients_pt from '../../pages/Clients/translate/pt.json'
import pageProducts from '../../pages/ProductGroups/translate/pt.json'
import pageServices from '../../pages/Services/translate/pt.json'

// pages/**
import pageAttendanceScreen from '../../pages/Attendance/translate/pt.json'
import pageBillsToPay from '../../pages/BillsToPay/translate/pt.json'
import pageBillsToReceive from '../../pages/BillsToReceive/translate/pt.json'
import pageCardsMedia from '../../pages/CardsMediaClients/translate/pt.json'
import pageCheckout from '../../pages/Checkout/translate/pt.json'
import pageComparisons from '../../pages/Comparisons/translate/pt.json'
import pageCreatingForms from '../../pages/CreatingForms/translate/pt.json'
import pageDocumentPrint from '../../pages/DocumentPrint/translate/pt.json'
import pageDocumentsServices from '../../pages/DocumentsServices/translate/pt.json'
import pageExamRequest from '../../pages/ExamRequest/translate/pt.json'
import pageMeansToReceipts from '../../pages/MeansToReceipts/translate/pt.json'
import pagePaymentBill from '../../pages/PaymentBill/translate/pt.json'
import pageProductsItems from '../../pages/ProductItems/translate/pt.json'
import pageProductsItemsResale from '../../pages/ProductItemsResale/translate/pt.json'
import pageProductsHistory from '../../pages/ProductsHistory/translate/pt.json'
import pageRealizedCashFlow from '../../pages/RealizedCashFlow/translate/pt.json'
import pageRecipe from '../../pages/Recipe/translate/pt.json'
import pageReportsTransfer from '../../pages/reportsTransfer/translate/pt.json'
import pageScheduling from '../../pages/Scheduling/translate/pt.json'
import pageClinic from '../../pages/Settings/AboutClinic/translate/pt.json'
import pageAttendance from '../../pages/Settings/Attendance/translate/pt.json'
import pageCostCenters from '../../pages/Settings/CostCenters/translate/pt.json'
import pageConvenio from '../../pages/Settings/Covenants/translate/pt.json'
import pageOrigins from '../../pages/Settings/Origins/translate/pt.json'
import pagePaymentSources from '../../pages/Settings/PaymentSources/translate/pt.json'
import pageRequiredFields from '../../pages/Settings/RequiredFields/translate/pt.json'
import pageSuppliers from '../../pages/Settings/Suppliers/translate/pt.json'
import pageTags from '../../pages/Settings/Tags/translate/pt.json'
import pageUsers from '../../pages/Settings/Users/translate/pt.json'
import pageTagsServices from '../../pages/TagsServices/translate/pt.json'
import pageTaxControl from '../../pages/TaxControl/translate/pt.json'
import pageTaxUnitControl from '../../pages/TaxControlUnit/translate/pt.json'
import pageBudgets from '../../pages/Budgets/translate/pt.json'
import pageIndications from '../../pages/Indications/translate/pt.json'
import pageDailyBox from '../../pages/DailyBox/translate/pt.json'
import pageReportsFinancial from '../../pages/ReportsFinancial/translate/pt.json'
import pageReportsServicesAndProducts from '../../pages/ReportsServicesAndProducts/translate/pt.json'
import pageReportsMarketing from '../../pages/ReportsMarketing/translate/pt.json'
import pageTicketsCanceled from '../../pages/TicketsCanceled/translate/pt.json'
import pageBlockTimes from '../../pages/BlockTimes/translate/pt.json'
import pageEquipments from '../../pages/Settings/Equipments/translate/pt.json'
import pageRegisterClinic from '../../pages/RegisterClinic/translate/pt.json'
import pageReportsOperation from '../../pages/ReportsOperation/translate/pt.json'
import pageNotes from '../../pages/Notes/translate/pt.json'
import pagePayments from "../../pages/Payments/translate/pt.json"
import pageConnections from "../../pages/Integrations/Connections/translate/pt.json"
import pageBirthdayPeople from "../../pages/Integrations/BirthdayPeople/translate/pt.json"

export const pt = {
  header: header_pt,
  sidebar: sidebar_pt,
  AddRecordUniq,
  printButton,
  pageClients: pageClients_pt,
  pageClinic,
  pageUsers,
  pageConvenio,
  pageAttendance,
  pageTags,
  pageOrigins,
  pageRequiredFields,
  pageSuppliers,
  pageProducts,
  pageServices,
  pageCostCenters,
  pagePaymentSources,
  pageBillsToPay,
  pagePaymentBill,
  pageScheduling,
  pageTagsServices,
  pageDocumentsServices,
  pageAttendanceScreen,
  pageRecipe,
  pageExamRequest,
  pageCardsMedia,
  documentContext,
  webcamStreamComponent,
  pageComparisons,
  pageMeansToReceipts,
  pageCreatingForms,
  pageBillsToReceive,
  pageCheckout,
  pageProductsItems,
  pageProductsHistory,
  pageRealizedCashFlow,
  pageTaxControl,
  pageTaxUnitControl,
  pageDocumentPrint,
  pageReportsTransfer,
  pageProductsItemsResale,
  pageBudgets,
  pageIndications,
  pageDailyBox,
  pageReportsFinancial,
  pageReportsServicesAndProducts,
  pageReportsMarketing,
  pageTicketsCanceled,
  pageBlockTimes,
  pageEquipments,
  pageRegisterClinic,
  pageReportsOperation,
  pageNotes,
  pagePayments,
  pageConnections,
  pageBirthdayPeople,
  global: {
    btnUpdate: 'Atualizar',
    btnNovo: 'Novo',
    paymentHeader: "Finalize seu pagamento",
    paymentDetails: "Revise os detalhes e confirme para prosseguir.",
    payment: "Pagar Agora",
    dropzoneLabel: 'Clique ou arraste arquivos aqui',
    dropzoneLabelError: 'Arquivo não suportado!',
    dropzoneLabelSuccess: 'Arquivo suportado.',
    dropzoneLabelSize: 'Atenção! arquivos até',
    modalData: 'Gostaria de baixar o documento?',
    noOptionsMessage: 'Sem opções para selecionar',
    modalDataDescription:
      'Seu documento aparecera na lista de downloads quando concluído!',
    remove: 'Excluir',
    documentComponent: {
      i1: 'Tipo de documento',
      i1Option: {
        i1: 'CPF',
        i2: 'CNPJ',
        i3: 'Outros'
      },
      i2: 'Documento'
    }
  }
}
